import { render, staticRenderFns } from "./distributionUrllinkTypeStat.vue?vue&type=template&id=1661ea70&"
import script from "./distributionUrllinkTypeStat.vue?vue&type=script&lang=js&"
export * from "./distributionUrllinkTypeStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports